// AUTO-GENERATED by scripts/build-pacing.cjs — do not edit by hand.
// Source: pacing worksheet (Pause points + Chapter load tabs) + content/pacing-overrides.json.
//
// PAUSE_POINTS: after completing a keyed step, the app may offer a gentle pause
// (always tap-past, never a lock). Scope: ["act1"] — other acts stay
// at their defaults until reviewed. An optional `handoff` suggests a follow-on.
// CHAPTER_LOAD: intro flows freely; core uses the pause/backstop brake; skill is
// consumed whole then pauses at the end. A silent signal — never shown to users.

export type Handoff = 'meditation' | 'calm' | 'journal';
export type ChapterLoad = 'intro' | 'core' | 'skill';
export interface PausePoint {
  handoff?: Handoff;
}

export const PAUSE_POINTS: Record<string, PausePoint> = {
  "act1-c03-l08-r": {},
  "act1-c03-l17": {},
  "act1-c04-l05": {},
  "act1-c05-l07-r": {},
  "act1-c05-l08-r": {},
  "act1-c05-l10-r": {},
  "act1-c05-l13": {},
  "act1-c07-l03-r": {},
  "act1-c07-l05-r": {},
  "act1-c07-l08-r": {},
  "act1-c07-l12-r": {},
  "act1-c07-l13-r": {},
  "act1-c07-l18": {},
  "act1-c08-l04": {},
  "act1-c09-l13b": {},
  "act1-c09-l15": {},
  "act1-c09-l17-r": {},
  "act1-c09-l18-r": {},
  "act1-c10-l04b": {},
  "act1-c11-l04b": {},
  "act1-c11-l07-r": {},
  "act1-c11-l09-r": {},
  "act1-c11-l11-r": {},
  "act1-c11-l20": {},
  "act1-c12-l10": {},
};

export const CHAPTER_LOAD: Record<string, ChapterLoad> = {
  "act1-c01": "intro",
  "act1-c02": "intro",
  "act1-c03": "core",
  "act1-c04": "skill",
  "act1-c05": "core",
  "act1-c06": "intro",
  "act1-c07": "core",
  "act1-c08": "skill",
  "act1-c09": "core",
  "act1-c10": "intro",
  "act1-c11": "core",
  "act1-c12": "core",
  "act1-c13": "intro",
  "act2-c01": "intro",
  "act2-c02": "core",
  "act2-c03": "core",
  "act2-c04": "core",
  "act2-c05": "core",
  "act2-c06": "core",
  "act2-c07": "intro",
  "act3-c01": "core",
  "act3-c02": "core",
  "act3-c04": "core",
  "act3-c06": "core",
  "act3-c08": "core",
  "act3-c10": "core",
  "act3-c12": "core",
  "act3-c13": "intro",
  "sc-c00": "intro",
  "sc-c01": "core",
  "sc-c02": "core",
  "sc-c03": "core",
  "sc-c04": "core",
  "sc-c05": "core",
  "sc-c06": "core",
};

export function pausePointFor(stepId: string): PausePoint | undefined {
  return PAUSE_POINTS[stepId];
}

export function chapterLoadFor(chapterId: string): ChapterLoad | undefined {
  return CHAPTER_LOAD[chapterId];
}
